/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { showToast } from 'vant';
import { addVrmDeviceCollect, delVrmDeviceCollect } from '@/service/vibrationEquipment';
export default defineComponent({
  name: 'VibDeviceListItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  emits: ['update'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var router = useRouter();
    var updateFocusAsync = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(props.item.isShow !== 1)) {
                _context.next = 4;
                break;
              }
              showDialog.value = true;
              _context.next = 14;
              break;
            case 4:
              _context.prev = 4;
              data = {
                deviceId: props.item.deviceId
              };
              _context.next = 8;
              return delVrmDeviceCollect(data);
            case 8:
              emit('update', props.item.deviceId, props.index);
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              showToast('修改失败');
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 11]]);
      }));
      return function updateFocusAsync() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onSubmit = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              data = {
                factoryId: props.item.factoryId,
                deviceId: props.item.deviceId,
                vrmWarnValue: vrmWarnValue.value,
                currentWarnValue: currentWarnValue.value
              };
              _context2.next = 4;
              return addVrmDeviceCollect(data);
            case 4:
              console.log(props.item.deviceId, '1');
              console.log(props.index, '2');
              emit('update', props.item.deviceId, props.index);
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              showToast('修改失败');
            case 12:
              showDialog.value = false;
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 9]]);
      }));
      return function onSubmit() {
        return _ref3.apply(this, arguments);
      };
    }();
    // 任意整数或小数
    var pattern = /^[0-9]*([.][0-9]{1,2})?$/;
    var showDialog = ref(false);
    var currentWarnValue = ref(700);
    var vrmWarnValue = ref(2);
    var toCurve = function toCurve(obj) {
      router.push({
        name: 'Curve',
        query: {
          deviceId: obj.deviceId,
          deviceIndex: obj.index,
          vrmWarnValue: obj.vrmWarnValue,
          currentWarnValue: obj.currentWarnValue,
          factoryId: obj.factoryId
        }
      });
    };
    return {
      toCurve: toCurve,
      pattern: pattern,
      showDialog: showDialog,
      updateFocusAsync: updateFocusAsync,
      onSubmit: onSubmit,
      currentWarnValue: currentWarnValue,
      vrmWarnValue: vrmWarnValue
    };
  }
});